<template>
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          @click="addCost"
          :disabled="!canEdit"
          v-if="canEdit"
          >添加费用</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <mytable
      :maxHeight="300"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      :isselection="false"
      ref="mytable"
    >
      <el-table-column slot="extra_remarks" label="图片">
        <el-button type="text" @click.stop="checkPic">查看</el-button>
      </el-table-column>
    </mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!-- 添加费项弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      class="cost_dia"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="dialogFormItems"
                prop="paymentMethodConfDictId"
                label="付款方式:"
              >
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm.paymentMethodConfDictId"
                  placeholder="请选择"
                  value-key="confDictId"
                  @change="changePayMethod"
                >
                  <el-option
                    v-for="item in settlementMethodList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="dialogFormItems"
                prop="deptId"
                label="支付部门"
              >
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm.deptId"
                  placeholder="请选择"
                  @change="changeDept"
                >
                  <el-option
                    v-for="dept in businessDepts"
                    :key="dept.deptId"
                    :label="dept.deptName"
                    :value="dept.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                style="width: 500px"
                class="dialogFormItems"
                prop="objectStatusConfDictId"
                required
                label="结算对象:"
              >
                <div class="multipleSelect">
                  <el-select
                    filterable
                    clearable
                    v-model="dialogForm.objectStatusConfDictId"
                    placeholder="请选择"
                    @change="changeObjestStatus"
                  >
                    <el-option
                      v-for="(item, index) in objectStatusList"
                      :key="index"
                      :label="item.val"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    filterable
                    clearable
                    v-model="dialogForm.objectName"
                    placeholder="请选择"
                    :allow-create="dialogForm.objectStatusType == 'other'"
                    remote
                    :remote-method="getObjectUserDownListYf"
                    @change="changeobjectName"
                  >
                    <el-option
                      v-for="(item, index) in CustomerListsYF"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item class="dialogFormItems" label="垫付人:">
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm.preparerEmployeeId"
                  placeholder="请选择"
                  @change="changePrepareEmployee"
                >
                  <el-option
                    v-for="emp in emps"
                    :key="emp.employeeId"
                    :label="emp.jobNumber"
                    :value="emp.employeeId"
                  >
                    <span style="float: left">{{ emp.jobNumber }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ emp.employeeName }}</span
                    >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                class="dialogFormItems listItems"
                :label="'费项与金额:'"
                style="width: 100%"
              >
                <div
                  class="items"
                  style="display: flex; width: 95%"
                  v-for="(financeOutInfo, index) in financeOutInfos"
                  :key="index + 'foi'"
                >
                  <div class="multipleSelect item-category-container">
                    <el-select
                      filterable
                      clearable
                      v-model="financeOutInfo.itemCategoryId"
                      placeholder="请选择费项类型"
                      @change="changeItemCategoryIdYF(index)"
                    >
                      <el-option
                        v-for="(item, index) in categoryNameList"
                        :key="index + 'cn'"
                        :label="item.categoryName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-select
                      allow-create
                      filterable
                      clearable
                      v-model="financeOutInfo.itemServiceId"
                      placeholder="请选择费项"
                      @change="changeItemServiceId(index)"
                    >
                      <el-option
                        v-for="(item, index) in CategoryServiceList"
                        :key="index + 'cs'"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-input
                      class="el-input233"
                      v-model="financeOutInfo.amount"
                      type="number"
                      placeholder="请输入金额"
                    ></el-input>
                  </div>
                  <div
                    class="iconList"
                    style="
                      margin-left: 10px;
                      width: 80px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <el-popconfirm
                      v-if="financeOutInfos.length > 1"
                      title="确定删除该行费项信息吗"
                      @confirm="delCategory(index)"
                    >
                      <i slot="reference" class="el-icon-remove iconSize"></i>
                    </el-popconfirm>
                    <i
                      v-if="
                        index == financeOutInfos.length - 1 &&
                        !dialogForm.financeId
                      "
                      style="margin-left: 10px"
                      class="el-icon-circle-plus iconSize"
                      @click="addCategory(index)"
                    ></i>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="3"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <my-image-upload
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></my-image-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <my-image-view :show.sync="showViewer" :url-list="previewSrcList" />
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
import MyImageView from "@/components/MyImageView.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    sorttable,
    paging,
    mytable,
    myDialog,
    MyImageView,
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    loadOrderId: {},
    dispatchId: {},
  },
  data() {
    return {
      pageGroupName: "dispatch_update_detail_finance_out", //  页面标识
      reportFiledsNumber: "admin_dispatch_load_detail_service_fee_list_v5", // 动态 条件、表头
      isShowOperate: this.canEdit, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "carFeeEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "删除",
          methods: "carFeeDel",
          param: 2,
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "修改运单号",
          command: "updateNumber",
        },
        {
          name: "修改基本信息",
          command: "updateInfo",
        },
      ],
      //需要单独点击的列字段名数组
      fieldList: ["commandNumber"],
      Operatewidth: "220px", //操作列的列宽
      //---  添加费项弹窗 -----
      isShowDialog: false,
      dialogTitle: "添加费用",
      diaWidth: "850px",
      dialogForm: {
        // 弹窗表单数据
        paymentMethodConfDictId: "",
        objectStatusType: "",
        objectName: "",
        objectNumber: "",
        preparerEmployeeId: "",
        financeId: "",
        remarks: "",
        objectStatusConfDictId: "",
        deptId: "",
        files: [],
      },
      financeOutInfos: [
        {
          itemCategoryId: "",
          itemCategoryName: "",
          itemServiceId: "",
          itemServiceName: "",
          amount: "",
          files: [],
        },
      ],
      visible: false,
      rulesForm: {
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      objectStatusList: [], //结算对象类型
      CustomerListsYF: [], //对象列表
      categoryNameList: [], //费项类型
      CategoryServiceList: [], //费项
      settlementMethodList: [], //付款方式
      employeeList: [],
      /**---------------- */
      fileNameLists: [], // 图片列表
      businessDepts: [],
      emps: [],
      tableData_1: [],
      previewSrcList: [],
      showViewer: false,
      prevOverflow: "",
      firstOne: 0,
      editRow: null,
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    this.getConfDictValDownList("settlement_method", "settlementMethodList");
    this.getConfDictValDownList("object_status", "objectStatusList"); // //车辆分类
    this.getConfDictValDownList("settlement_method"); //付款方式
    this.getConfDictValDownList("object_status"); //获取结算对象类型
    // 获取接单网点
    this.getBusinessDepts();
    // 员工
    this.getEmps();
    await this.getData({
      loadOrderId: this.loadOrderId,
    });
    this.tableData_1 = this.tableData.filter(
      (item) => item.operationType != "DEL"
    );
  },
  methods: {
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 添加费用
    addCost() {
      this.isShowDialog = true;
      this.itemCategorChoose();
      this.financeOutInfos = [{}];
      this.fileNameLists = [];
      this.dialogForm = {};
    },
    // 新增一个费项
    addCategory() {
      this.financeOutInfos.push({
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        amount: "",
      });
    },
    // 删除一个费项
    delCategory(pos) {
      this.financeOutInfos.splice(pos, 1);
    },
    // 费型类型下拉列表
    async itemCategorChoose(categoryName) {
      // this.$API
      //   .itemCategorChoose({ categoryName: categoryName })
      //   .then((res) => {
      //     this.categoryNameList = res.data.result || [];
      //   });
      const res = await this.$API.runList({
        number: "down_list_item_category",
        categoryName: categoryName,
      });
      this.categoryNameList = res;
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF(idx) {
      if (this.financeOutInfos[idx].itemCategoryId) {
        this.wtl_itemServiceListAll(
          this.financeOutInfos[idx].itemCategoryId,
          "fu:direction_status"
        );
        this.categoryNameList.forEach((item) => {
          if (item.id == this.financeOutInfos[idx].itemCategoryId) {
            this.financeOutInfos[idx].itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.financeOutInfos[idx].itemServiceId = "";
        this.financeOutInfos[idx].amount = "";
        this.financeOutInfos[idx].itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .runList({
          number: "down_list_item_service",
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res || [];
        });
    },
    //选择费项(应付弹窗)
    changeItemServiceId(idx) {
      if (this.financeOutInfos[idx].itemServiceId) {
        const one = this.CategoryServiceList.filter(
          (item) => item.id === this.financeOutInfos[idx].itemServiceId
        );
        if (one.length > 0) {
          this.$set(this.financeOutInfos[idx], "amount", one[0].unitPrice || 0);
          this.financeOutInfos[idx].itemServiceName = one[0].title;
        }
      } else {
        this.financeOutInfos[idx].amount = "";
        this.financeOutInfos[idx].itemServiceName = "";
      }
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(a) {
      this.isShowDialog = false;
      this.dialogForm = {
        // 弹窗表单数据
        paymentMethodConfDictId: "",
        objectStatusType: "",
        objectName: "",
        objectNumber: "",
        preparerEmployeeId: "",
        financeId: "",
        remarks: "",
        objectStatusConfDictId: "",
        deptId: "",
        files: [],
      };
      this.financeOutInfos = [
        {
          itemCategoryId: "",
          itemCategoryName: "",
          itemServiceId: "",
          itemServiceName: "",
          amount: 0,
          files: [],
        },
      ];
      this.fileNameLists = [];
      this.editRow = null;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(a) {
      this.isShowDialog = false;
      if (this.editRow) {
        Object.assign(this.editRow, this.financeOutInfos[0], this.dialogForm, {
          operationType: "UPDATE",
        });
        this.editRow.files = [...this.fileNameLists];
        this.$API
          .saveUnloadOrderFinance({
            loadOrderId: this.loadOrderId,
            saveType: "SAVE",
            fianceOutInfos: [{
              ...this.editRow,
              inoutStatus: "zhi_chu:inout_status",
              }],
          })
          .then((res) => {
            this.$message.success("保存成功");
          })
          .catch((err) => {
            this.$message.error("保存失败");
          });
      } else {
        this.financeOutInfos.map((item) => {
          this.tableData.push({
            ...item,
            files: [...this.fileNameLists],
            ...this.dialogForm,
            operationType: "ADD",
          });
        });
        const financeOutInfos = this.financeOutInfos.map((item) => {
          return {
            ...item,
            files: [...this.fileNameLists],
            ...this.dialogForm,
            operationType: "ADD",
            inoutStatus: "zhi_chu:inout_status",
          };
        });
        this.$API
          .saveUnloadOrderFinance({
            loadOrderId: this.loadOrderId,
            saveType: "SAVE",
            fianceOutInfos: financeOutInfos,
          })
          .then((res) => {
            this.$message.success("保存成功");
          })
          .catch((err) => {
            this.$message.error("保存失败");
          });
      }

      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(a) {
      this.handleCloseDia(a);
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    // 获取员工 employee
    getemployee(name) {
      return this.$API
        .wtl_getObjectUserDownList({
          key: "employee",
          name: name || "",
          pageStart: 1,
          pageTotal: 50,
        })
        .then((res) => {
          this.employeeList = res.data.result.data || [];
        });
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm.objectName = "";
      this.dialogForm.objectNumber = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.id == e) {
            this.dialogForm.objectStatusType = item.key;
            this.dialogForm.objectStatus = item.val;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    // (费用弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.dialogForm.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    // 车次费用表格操作按钮
    editTrainCost(row, type) {
      if (type == "edit") {
        // 编辑
      } else {
        // 删除
      }
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "storage") {
          this.storageList = res || [];
        }
      }); //获取网点列表
    },
    carFeeEdit(row) {
      this.itemCategorChoose();
      this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status");
      this.dialogForm = {
        ...row,
        paymentMethodConfDictId: row.paymentMethodConfDictId
          ? parseInt(row.paymentMethodConfDictId)
          : "",
        objectStatusConfDictId: row.objectStatusConfDictId
          ? parseInt(row.objectStatusConfDictId)
          : "",
      };
      this.financeOutInfos = [
        {
          ...row,
          itemCategoryId: row.itemCategoryId
            ? parseInt(row.itemCategoryId)
            : "",
          itemServiceId: row.itemServiceId ? parseInt(row.itemServiceId) : "",
        },
      ];
      if (!(row.files instanceof Array)) {
        this.$API
          .getFileUrlMore({ fileNames: row.files.split(",") })
          .then((res) => {
            let srcLists = res.data.result || [];
            row.files = srcLists.map((item) => {
              return {
                fileId: item.fileName,
                fileUrl: item.url,
              };
            });
            this.fileNameLists = row.files;
            this.isShowDialog = true;
            this.editRow = row;
          });
      } else {
        this.fileNameLists = row.files;
        this.isShowDialog = true;
        this.editRow = row;
      }
    },
    carFeeDel(row) {
      this.$confirm("是否删除该项费用")
        .then((res) => {
          row.operationType = "DEL";
          this.tableData_1 = this.tableData.filter(
            (item) => item.operationType != "DEL"
          );
          this.$API
            .saveUnloadOrderFinance({
              loadOrderId: this.loadOrderId,
              saveType: "SAVE",
              fianceOutInfos: [{
                ...row,
                files:[],
                inoutStatus: "zhi_chu:inout_status",
              }],
            })
            .then((res) => {
              this.$message.success("保存成功");
            })
            .catch((err) => {
              this.$message.error("保存失败");
            });
        })
        .catch((err) => {});
    },
    changePayMethod() {
      const dictId = this.dialogForm.paymentMethodConfDictId;
      const paymentMethod = this.settlementMethodList.filter(
        (item) => item.id == dictId
      )[0];
      this.dialogForm.paymentMethod = paymentMethod.val;
    },
    changeDept() {
      const deptId = this.dialogForm.deptId;
      const dept = this.businessDepts.filter(
        (item) => item.deptId == deptId
      )[0];
      this.dialogForm.deptName = dept.deptName;
    },
    changePrepareEmployee() {
      const preparerEmployeeId = this.dialogForm.preparerEmployeeId;
      const preparerEmployee = this.emps.filter(
        (item) => item.employeeId == preparerEmployeeId
      )[0];
      this.dialogForm.preparerEmployeeName = preparerEmployee.employeeName;
    },
    getRows() {
      return this.tableData.map((item, index) => {
        return {
          ...item,
          inoutStatus: "zhi_chu:inout_status",
          operationType: item.operationType || "UNCHANGED",
        };
      });
    },
    checkPic(event) {
      const row = this.$refs.mytable.getRow(event).row;
      if (!row.files || row.files.length == 0) {
        this.$message("无图片");
      }
      try {
        this.previewSrcList = row.files.map((item) => item.fileUrl);
        this.showViewer = true;
      } catch (err) {
        this.$API
          .getFileUrlMore({ fileNames: row.files.split(",") })
          .then((res) => {
            let srcLists = res.data.result || [];
            let arr1 = srcLists.map((imtes) => {
              return imtes.url;
            });
            row.files = srcLists.map((item) => {
              return {
                fileId: item.fileName,
                fileUrl: item.url,
              };
            });
            this.previewSrcList = arr1;
            this.showViewer = true;
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
.glo_btnList {
  margin-bottom: 10px;
}
.cost_dia {
  /deep/.el-dialog {
    .glo_dialogForm {
      .diaForm {
        .el-row {
          width: 100%;
          .multipleSelect {
            display: flex;
            /deep/ .el-select {
              flex: 1;
            }
          }
          .listItems {
            border: unset;
            height: auto;
            .el-form-item__content {
              height: auto;
              .items {
                margin-right: 3%;
                height: 36px;
                line-height: 36px;
                margin-bottom: 10px;
              }
              .multipleSelect {
                border: 1px solid #cccccc;
                border-radius: 4px;
                .el-input233 {
                  width: 30%;
                }
              }
              .iconList {
                align-items: center;
                height: 36px;
                .el-popover__reference-wrapper {
                  display: flex;
                  align-items: center;
                }
                .iconSize {
                  font-size: 26px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>